import { useState } from 'react'

type UseFormReturn<T> = {
    values: T
    setValue: <K extends keyof T>(key: K, value: T[K]) => void
    setValues: (values: Partial<T>) => void
    resetForm: () => void
}

function useForm<T>(initialValues: T): UseFormReturn<T> {
    const [values, setValuesState] = useState<T>(initialValues)

    const setValue = <K extends keyof T>(key: K, value: T[K]) => {
        setValuesState((prevValues) => ({
            ...prevValues,
            [key]: value,
        }))
    }

    const setValues = (newValues: Partial<T>) => {
        setValuesState((prevValues) => ({
            ...prevValues,
            ...newValues,
        }))
    }

    const resetForm = () => {
        setValuesState(initialValues)
    }

    return {
        values,
        setValue,
        setValues,
        resetForm,
    }
}

export default useForm
